import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { NavPanelData } from './ui.service-helper';

@Injectable({ providedIn: 'root' })
export class ViUIService {
  getLoader$: Subject<boolean> = new Subject<boolean>();
  sidenav$: Subject<void> = new Subject<void>();
  sidenavPanel$: Subject<void> = new Subject<void>();
  sidenavClosed$: Subject<void> = new Subject<void>();
  panelSidenavClosed$: Subject<void> = new Subject<void>();
  navPanelData$: BehaviorSubject<NavPanelData> = new BehaviorSubject<NavPanelData>({
    isOpen: false,
    width: 0,
  });

  hideBodyScrollbar(): void {
    const body = document.querySelector('body');
    body.classList.add('body-scrollblock');
  }

  unhideBodyScrollbar(): void {
    const body = document.querySelector('body');
    body.classList.remove('body-scrollblock');
  }
}
